// extracted by mini-css-extract-plugin
module.exports = {"resourcelist":"resources-styles-module--resourcelist--3WyCH"};